import { FC } from "react";
import { AdminHome } from "../../../modules/admin/components/screens/admin-home/admin-home";

export const AdminHomeRoute: FC = () => {
    return (
        <AdminHome />
    )
}